import React from 'react';
import * as S from '../RadioButton/RadioButton.styles';



type RadioBtnProps = {
  title?: string;
  isTitle?: boolean;
  isActive?: boolean;
}



const CustomRadioButton = ({title, isTitle=true,isActive}: RadioBtnProps) => (
  <S.RadioLabel>
    <S.RadioInput type="radio" checked={isActive}/>
    <S.Checkmark ></S.Checkmark>
    {(isTitle  && (<S.CheckboxText>{title}</S.CheckboxText>) || (''))}
  </S.RadioLabel>
   
);



export default CustomRadioButton;  